import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import { classNames } from 'primereact/utils';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Blog } from 'src/app/interfaces/Blog';
import {
  createStripePaymentIntent,
} from 'src/app/services/ClientService';
import { formatDateReadable } from 'src/app/utils/dateUtils';
import { formatBlogPath, truncateWords } from 'src/app/utils/valueUtils';
import { coverageCountries } from './data/coverage';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { getPlanSupportedCountries } from 'src/app/services/PlanService';
import { Toast } from 'primereact/toast';
import CountryListDialog from './components/CountryListDialog';
import axios, { AxiosResponse } from 'axios';
import SuccessDialog from './components/SuccessDialog';
import HeroHeader from './components/HeroHeader';
import { useTranslation } from 'react-i18next';
import { FaSimCard, FaGlobe } from 'react-icons/fa'; // Font Awesome
import { MdTimer } from 'react-icons/md';
import VerifyCardDialog from './components/VerifyCardDialog';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import VerifyingCardDialog from './components/VerifyingCardDialog';
import { environment } from 'src/environments/environment';
import NotEligibleDialog from './components/NotEligibleDialog';
import { checkCardEligibility } from 'src/app/services/EndUserService';
import { EligibilityResponse } from 'src/app/interfaces/ApiResponse';
import { set } from 'date-fns';
import { Turnstile, TurnstileInstance } from "@marsidev/react-turnstile";




interface DataError {
  message?: string;
  errors?: {
    [key: string]: string[];
  };
}
const LandingPage = () => {
  const [cardNumber, setCardNumber] = useState(''); //559900 for sample
  const [agree, setAgree] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const toast = useRef<Toast>(null);

  const [countries, setCountries] = useState<any[]>([]);
  const [showCreatePageDialog, setShowCountryListDialog] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showNotEligibleDialog, setShowNotEligibleDialog] = useState(false);
  const [showVerifyCardDialog, setShowVerifyCardDialog] = useState(false);
  const [showVerifyingCardDialog, setShowVerifyingCardDialog] = useState(false);

  const { t } = useTranslation();

  const stripePromise = loadStripe(environment.STRIPE_PUBLIC_KEY);
  const [clientSecret, setClientSecret] = useState<string | undefined>();
  const [paymentIntentId, setPaymentIntentId] = useState<string>('');
  const [isPreAuthRequired, setIsPreAuthRequired] = useState(false);
  const [eligibilityResponse, setEligibilityResponse] = useState<EligibilityResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const turnstileRef = useRef<TurnstileInstance>(null);

  const howItWorks = [
    {
      status: t('landing.step_1_title'),
      title: t('landing.step_1_heading'),
      steps: [t('landing.step_1_description')],
      icon: 'pi pi-credit-card',
      color: '#0a3a66',
      img_url: '../../../assets/visual_assets/icon-card.svg',
    },
    {
      status: t('landing.step_2_title'),
      title: t('landing.step_2_heading'),
      steps: [t('landing.step_2_description')],
      icon: 'pi pi-gift',
      color: '#0a3a66',
      img_url: '../../../assets/visual_assets/icon-reward.svg',
    },
    {
      status: t('landing.step_3_title'),
      title: t('landing.step_3_heading'),
      steps: [
        t('landing.step_3_description_1'),
        t('landing.step_3_description_2'),
      ],
      icon: 'pi pi-send',
      color: '#0a3a66',
      img_url: '../../../assets/visual_assets/icon-flight.svg',
    },
  ];

  const benefits = [
    {
      img_url: '../../../assets/visual_assets/benefit-landing.svg',
      title: t('landing.step_3_description_1'),
    },
    {
      img_url: '../../../assets/visual_assets/benefit-queue.svg',
      title: t('landing.benefit_no_sim_hassle'),
    },
    {
      img_url: '../../../assets/visual_assets/benefit-network.svg',
      title: t('landing.benefit_multiple_networks'),
    },
    {
      img_url: '../../../assets/visual_assets/benefit-single-esim.svg ',
      title: t('landing.benefit_reusable_esim'),
    },
    {
      img_url: '../../../assets/visual_assets/benefit-flexible-date.svg',
      title: t('landing.benefit_flexible_start'),
    },
    {
      img_url: '../../../assets/visual_assets/benefit-share.svg',
      title: t('landing.benefit_data_sharing'),
    },
  ];

  const header = (
    <div className="eligibility-card-header">
      <div
        className="flex align-items-center justify-content-start"
        style={{
          background: '#000000',
          padding: '12px 16px',
          borderBottomRightRadius: '20px',
          borderTopLeftRadius: '20px',
          width: 'fit-content',
        }}
      >
        <img
          alt="Card"
          src="../../assets/visual_assets/mastercard-title.png"
          style={{ height: 'auto', width: '160px' }}
        />
      </div>
    </div>
  );

  const footer = (
    <Button
      className="w-full justify-content-center"
      label={!loading ? t('landing.check_card_eligibility_button') : undefined}
      icon={loading ? 'pi pi-spinner pi-spin' : undefined}
      iconPos="left"
      disabled={!agree || cardNumber.length !== 16 || !captchaToken} 
      onClick={() => checkEligibility(cardNumber as unknown as number)}
    />
  );

  const fetchPlanSupportedCountries = async () => {
    try {
      const response = (await getPlanSupportedCountries()) as AxiosResponse;
      console.log('response ', response);
      const localCountries = response?.data?.data['country'];
      const regions = response?.data?.data['regions'];

      setCountries(localCountries);
      // setCountries([...localCountries, ...regions]);
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load countries.',
        life: 3000,
      });
    }
  };

  const checkEligibility = async (lookup_value: number) => {
    if (!captchaToken) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Verification Required',
        detail: 'Please complete verification',
        life: 3000,
      });
      return;
    }

    setLoading(true);

    try {
      const response = await checkCardEligibility(lookup_value, captchaToken);

      console.log('check response ', response);

      if (response?.status === 200 && response.data?.data?.payment_intent) {
        setEligibilityResponse(response.data);
        setClientSecret(response.data.data.payment_intent.client_secret);
        setPaymentIntentId(response.data.data.payment_intent.id);
        setIsPreAuthRequired(response.data.data.is_preauth_required);

        if (response.data.data.is_preauth_required === 1) {
          setShowVerifyCardDialog(true);
        } else {
          setShowSuccessDialog(true);
        }
      }
    } catch (error: any) {
      if (error?.response?.status === 422) {
        setEligibilityResponse(error.response.data);
        setShowNotEligibleDialog(true);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: error?.response?.data?.message ?? 'Something went wrong. Please try again.',
          life: 4000,
        });
      }
    }

    setLoading(false);
    setCaptchaToken(null); // 🔥 IMPORTANT: reset after use
  };

  const formatCardNumber = (value: string) => {
    return value
      .replace(/\D/g, '')
      .slice(0, 16)
      .replace(/(.{4})/g, '$1 ')
      .trim();
  };

  const handleOpenVerification = async () => {
    try {
      // const res = await createStripePaymentIntent();
      // console.log('Res ', res);

      // setClientSecret(res.clientSecret);
      // setPaymentIntentId(res.paymentIntentId); // ✅ store this

      setShowVerifyCardDialog(false);

      setTimeout(() => {
        setShowVerifyingCardDialog(true);
      }, 0);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchPlanSupportedCountries();
  }, []);

  return (
    <>
      <HeroHeader />

      <div className="w-full py-6">
        <div className="grid">
          <div className="col-12 lg:col-8 px-6">
            <h3 className="mb-3">
              {t('landing.roaming_powered_by_title')}
              <span className="font-bold"> {t('common.flexiroam')}</span>
            </h3>

            <p className="text-lg line-height-3 mb-5">
              {t('landing.roaming_powered_by_description')}
            </p>

            <p className="mb-3 bg-flexiroam-blue inline-flex align-items-center gap-2 text-white custom-chip font-semibold">
              <img
                src="../../../assets/visual_assets/icon-title 1.svg"
                alt="icon-title 1"
              />

              {t('landing.benefits_highlights_title')}
            </p>

            <p className="mb-5">
              <ul className="no-list">
                <li>
                  {/* <i className="pi pi-gift"></i> */}
                  <FaSimCard size={18} />
                  <span> {t('landing.esim_title')}</span>
                </li>
                <li>
                  <MdTimer size={18} />
                  <span>{t('landing.one_time_setup_title')}</span>
                </li>
                <li>
                  <FaGlobe size={18} />
                  <span>{t('landing.one_time_setup_description')}</span>
                </li>
              </ul>
            </p>

            <p className="mb-3 bg-flexiroam-blue inline-flex align-items-center gap-2 text-white custom-chip font-semibold">
              <img
                src="../../../assets/visual_assets/icon-title 2.svg"
                alt="icon-title 2"
              />
              {t('landing.eligibility_enrollment_title')}
            </p>

            <p className="mb-5">
              {t('landing.eligibility_enrollment_description')}
            </p>

            <p className="mb-3 bg-flexiroam-blue inline-flex align-items-center gap-2 text-white custom-chip font-semibold">
              <img
                src="../../../assets/visual_assets/icon-title 3.svg"
                alt="icon-title 3"
              />
              {t('landing.termination_title')}
            </p>

            <p className="mb-3">{t('landing.termination_description')}</p>
          </div>
          <div className="col-12 lg:col-4 p-6 ">
            <Card
              footer={footer}
              header={header}
              className="md:w-25rem border-round-3xl overflow-hidden"
            >
              {' '}
              <p className="font-bold text-lg mb-3">
                {' '}
                {t('landing.program_name')}
              </p>
              <p className="font-normal mb-5">{t('landing.program_tagline')}</p>
              <div className="flex flex-column gap-2">
                <label htmlFor="cardNumber">
                  {' '}
                  {t('landing.check_eligibility_button')}
                </label>

                <span className="p-input-icon-left p-input-icon-right w-full">
                  <i className="pi pi-credit-card"></i>
                  {/* Testing Range - 5599000000000000 - 5599999999999999 */}
                  <InputText
                    id="cardNumber"
                    type={showCard ? 'text' : 'password'}
                    value={formatCardNumber(cardNumber)}
                    inputMode="numeric"
                    placeholder={t('landing.enter_card_number_placeholder')}
                    className="w-full"
                    onChange={(e) => {
                      const raw = e.target.value
                        .replace(/\D/g, '')
                        .slice(0, 16);
                      setCardNumber(raw);
                    }}
                    style={
                      !showCard
                        ? { letterSpacing: '2px', fontFamily: 'monospace' }
                        : undefined
                    }
                  />

                  <i
                    className={`pi ${showCard ? 'pi-eye-slash' : 'pi-eye'
                      } cursor-pointer`}
                    onClick={() => setShowCard((prev) => !prev)}
                  ></i>
                </span>
                <div className="mt-3 flex justify-content-center">
                  <Turnstile
                    ref={turnstileRef}
                    siteKey={environment.REACT_APP_TURNSTILE_SITE_KEY}
                    onSuccess={(token) => {
                      console.log("Turnstile Token:", token);
                      setCaptchaToken(token);
                    }}
                    onExpire={() => setCaptchaToken(null)}
                  />
                </div>
              </div>
              <div className="flex align-items-start mb-2 mt-3">
                <Checkbox
                  inputId="chkbox1"
                  checked={agree}
                  onChange={(e) => setAgree(e.checked ?? false)}
                  className="mr-2 mt-1"
                />

                <label
                  htmlFor="chkbox1"
                  className="text-xs text-500 line-height-3 font-normal"
                  style={{ maxWidth: '100%' }}
                >
                  {t('landing.consent_text')}
                </label>
              </div>
            </Card>
          </div>
        </div>
      </div>

      <div className="w-full py-6 surface-100">
        <div className="grid">
          <div className="col-12 lg:col-12 px-6">
            <h3 className="mb-3 text-center">
              {t('landing.stay_connected_title')}&nbsp;
              <span className="font-bold">{t('landing.120_countries')}</span>
            </h3>

            <p className="mb-3 text-center">
              {t('landing.stay_connected_description')}
            </p>

            <div className="grid grid-nogutter surface-100 border-round-lg p-3 text-center">
              {countries &&
                countries.slice(0, 12).map((country: any) => (
                  <div
                    key={country.iso_code_alpha_2}
                    className="col-12 md:col-4 lg:col-3 p-2"
                  >
                    <div className="border-1 border-gray-300 surface-card p-3 border-round-lg flex align-items-start gap-2">
                      <img
                        src={`https://flagcdn.com/w40/${country.iso_code_alpha_2.toLowerCase()}.png`}
                        alt={country.display_title}
                        style={{
                          width: '32px',
                          height: '24px',
                          objectFit: 'cover',
                        }}
                      />
                      <span className="font-bold">{country.display_title}</span>
                    </div>
                  </div>
                ))}
            </div>
            {countries && countries?.length > 12 && (
              <div className="text-center mt-4">
                <Button
                  label={t('landing.destinations_button')}
                  onClick={() => setShowCountryListDialog(true)}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="w-full py-6">
        <div className="grid">
          <div className="col-12 px-6">
            <h3 className="mb-3 text-center">
              {' '}
              {t('landing.how_it_works_title')}
            </h3>

            <p className="mb-5 text-center">
              {t('landing.how_it_works_subtitle')}
            </p>

            <div className="grid grid-nogutter border-round-lg p-3 text-center">
              {howItWorks.map((step: any, index: number) => (
                <div key={index} className="col-12 md:col-4 p-3">
                  <div
                    className="surface-100 border-gray-300 p-4 border-round-lg flex flex-column align-items-center gap-3"
                    style={{ height: '301px' }}
                  >
                    <div
                      className="flex align-items-center justify-content-center border-circle"
                      style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: step.color,
                        color: 'white',
                      }}
                    >
                      <img src={step.img_url} alt="icon-how-it-works" />
                    </div>

                    <span
                      className="text-sm text-600"
                      style={{ textWrap: 'stable' }}
                    >
                      {step.status}
                    </span>

                    <span
                      className="font-bold text-lg"
                      style={{ textWrap: 'stable' }}
                    >
                      {step.title}
                    </span>

                    <ul
                      className="list-none p-0 m-0 text-sm line-height-3 text-900"
                      style={{ textWrap: 'stable' }}
                    >
                      {step.steps.map((s: string, i: number) => (
                        <li key={i}>
                          <span className="flex">{s}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full py-6 surface-100">
        <div className="grid">
          <div className="col-12 lg:col-12 px-6">
            <h3 className="mb-3 text-center">
              <span className="font-bold"> {t('landing.benefits_title')}</span>{' '}
              {t('landing.of')} {t('common.flexiroam')}
            </h3>

            <div className="grid grid-nogutter border-round-lg p-3 text-center">
              {benefits.map((benefit: any, index: number) => (
                <div key={index} className="col-12 md:col-4 p-3 flex">
                  <div className="bg-white  p-5 border-round-lg flex flex-column align-items-center gap-4 w-full h-full">
                    {/* Benefit Icon */}
                    <img
                      src={benefit.img_url}
                      alt={benefit.title}
                      style={{
                        width: '70px',
                        height: '70px',
                        objectFit: 'contain',
                      }}
                    />

                    {/* Benefit Title */}
                    <span
                      className="font-semibold text-900 text-center line-height-3"
                      style={{ maxWidth: '260px', textWrap: 'stable' }}
                    >
                      {benefit.title}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CountryListDialog
        visible={showCreatePageDialog}
        onClose={() => setShowCountryListDialog(false)}
        header={'Destinations'}
      />

      <VerifyCardDialog
        visible={showVerifyCardDialog}
        onClose={() => setShowVerifyCardDialog(false)}
        onVerify={handleOpenVerification}
        cardNumber={cardNumber ? cardNumber : null}
        data={eligibilityResponse}
      />

      {eligibilityResponse && clientSecret && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <VerifyingCardDialog
            visible={showVerifyingCardDialog}
            onClose={() => setShowVerifyingCardDialog(false)}
            onVerificationComplete={(skipConfirmRedemption) => {
              console.log('skipConfirmRedemption ', skipConfirmRedemption);
              console.log('redemption id ', eligibilityResponse?.data?.redemption_id);
              setShowVerifyingCardDialog(false);
              if (skipConfirmRedemption === true) {
                navigate('/redeem/offer?redemption_id=' + eligibilityResponse?.data?.redemption_id);
              } else {
                setShowSuccessDialog(true);
              }
            }}
            cardNumber={cardNumber || null}
            clientSecret={clientSecret}
            paymentIntentId={paymentIntentId}
          />
        </Elements>
      )}

      <SuccessDialog
        visible={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        header={'Success'}
        cardNumber={cardNumber ? cardNumber : null}
        data={eligibilityResponse}
      />

      <NotEligibleDialog
        visible={showNotEligibleDialog}
        onClose={() => {
          setShowNotEligibleDialog(false);
          setCardNumber('');
          setAgree(false);
          setCaptchaToken(null);
          turnstileRef.current?.reset();
        }}
        header={'Not Eligible'}
        data={eligibilityResponse}
      />
    </>
  );
};

export default LandingPage;

